const formatearCantidad = (cantidad) => {
	// eslint-disable-next-line no-undef
	return new Intl.NumberFormat(
		'es-CR',
		{style: 'currency', currency: 'CRC', minimumFractionDigits: 0}
	).format(cantidad);
}
 
export default formatearCantidad;